import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

import styles from "./PortfolioArticle.module.css";
import Header from "Page/common/components/Header";
import BackBtn from "Page/common/components/BackBtn";

export default function PortfolioArticle(props) {
  const location = useLocation();
  const { category } = props;
  const { article_id } = location.state;
  let [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/portfolio/article/${article_id}`)
      .then((res) => {
        console.log(res.data);
        setData([...data, ...res.data]);
      });
  }, [location.pathname]);

  return (
    <div className={styles.PortfolioArticle}>
      <Header
        title={
          data.length === 0
            ? ""
            : data[0].category_id === 8
            ? "제품 납품"
            : "외주 현황"
        }
      />
      {data.length !== 0 ? (
        <div className={styles.Article}>
          <div className={styles.TitleDiv}>
            <div className={styles.Title}>{data[0].title}</div>
            <div className={styles.Date}>
              {data[0].uploaded_at.slice(0, 10)}
            </div>
          </div>

          <div className={styles.Content}>
            {data[0].image.map((img, index) => {
              return (
                <img
                  className={styles.Photo}
                  src={`${process.env.REACT_APP_URL}/api/common/image/${img}`}
                  alt={"null.jpg"}
                  key={index}
                />
              );
            })}
            {data[0].content}
          </div>
        </div>
      ) : (
        <div />
      )}

      <BackBtn title="목록" />
    </div>
  );
}
